<template>
	<vxe-modal size="mini" v-model="modalShow" width="600" height="300" show-footer destroy-on-close @show="show" @hide="hide"
		transfer :lock-scroll="false">
		<template #title>
			<div>
				{{extra.title?extra.title:'进项审核'}}
			</div>
		</template>
		<template #default>
			<div>
				<el-form ref="auditForm" :model="form" label-width="80px" size="mini" :rules="rules"
					:show-message="false">
					<el-form-item label="发票品名" prop="invoicetypeid">
						<el-select v-model="form.invoicetypeid" filterable>
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="数量" style="margin-top: 10px;" prop="num" v-if="extra.type!='total'">
						<el-input-number v-model="form.num" :min="0" :max="extra.row.num"></el-input-number>
					</el-form-item>
				</el-form>
			</div>
			<transition name="el-fade-in-linear">
				<div class="full flex form_loading" v-if="loading"
					style="background-color: white;z-index: 999;color: #409EFF;">
					<i class="vxe-icon-refresh roll"></i>
					<span>正在加载</span>
				</div>
			</transition>
		</template>
		<template #footer>
			<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
			<vxe-button status="primary" content="保存" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style>

</style>
<style scoped>
	.el-form-item {
		margin-bottom: 0px;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	export default {
		name: 'invoiceinputAudit',
		props: {
			extra: {
				type: Object,
				default: () => {
					return {}
				}
			}
		},
		data() {
			return {
				form: {
					invoicetypeid: null,
					num: 0,
				},
				loading: false,
				modalShow: true,
				allAlign: 'center',
				options: [],
				rules: {
					invoicetypeid: [{
						required: true,
						message: '请选择发票品名',
						trigger: 'change'
					}, ],
					num: [{
						required: true,
						message: '请填写数量',
						trigger: 'blur'
					}]
				}
			}
		},
		watch: {

		},
		created() {

			this.list()
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list() {
				this.$api.invoicetype.list({
					currentPage: -1
				}).then((res) => {
					res.list.forEach((item) => {
						this.options.push({
							value: item.id,
							label: item.name
						})
					})

				})
			},
			show() {

			},
			hide() {
				this.back('cancle')
			},
			submit() {
				this.$refs.auditForm.validate((valid) => {
					if (valid) {
						if (this.extra.type != 'total') {
							this.form.amount = this.extra.row.amount
							this.form.price = this.extra.row.price
							this.$api.invoiceinput.audit(this.extra.row.id, this.form).then(() => {
								this.$message.success('操作成功')
								this.back('update')
							})
						} else {

							this.$api.invoiceinput.audit('total', {
								ids: this.extra.ids,
								invoicetypeid:this.form.invoicetypeid
							}).then(() => {
								this.$message.success('操作成功')
								this.back('update')
							})
						}

					}
				});
			},
			back(type) {
				this.$emit('back', {
					type: type
				})
			},
		},
		components: {

		}
	}
</script>
